module.exports = __webpack_public_path__ + "img/property-w.svg";